import { render, staticRenderFns } from "./SakaniProductsForExecutives.vue?vue&type=template&id=4f6537f7&scoped=true"
import script from "./SakaniProductsForExecutives.vue?vue&type=script&lang=js"
export * from "./SakaniProductsForExecutives.vue?vue&type=script&lang=js"
import style0 from "./SakaniProductsForExecutives.vue?vue&type=style&index=0&id=4f6537f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6537f7",
  null
  
)

export default component.exports